import { AfterViewInit, Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { AuthService } from './shared/services/auth/auth.service';
import { IconService } from './shared/services/icon.service';
import { filter } from 'rxjs/operators';
import { RenderService } from './shared/services/render.service';
import { DataService } from './shared/services/data.service';
import { ConfigService } from './shared/services/config/config.service';
import { LocalizationService } from './shared/services/localization.service';
declare var window:any;
@Component({
  selector: 'app-root',
  template: '<router-outlet></router-outlet>',
})
export class AppComponent implements OnInit,AfterViewInit {

  constructor(private authService:AuthService,
    private iconSv: IconService,
    private router:Router,
    private renderService: RenderService,
    private dataService:DataService,
    private configService:ConfigService) {
    this.iconSv.registerIcons();
  }
  ngOnInit(): void {
    this.authService.init(); 
    //const cultureCode = (<HTMLInputElement>document.getElementById('cultureCode')).value;
    //this.dataService.setCultureCode(cultureCode);
    LocalizationService.getCurrentCultureCode();
    this.configService.init();
  }
  ngAfterViewInit() {
    
    //this.loadMainScript();
  }

  // loadMainScript() {
  //   console.log('loadMainScript');
  //   // Your code to load main.js here
  //   window.mainSlider();
  //   window.miniSlider();
  //   window.cardSlider();
  //   window.smallCardsSlider();
  //   window.cardsSlider();
  //   window.studySlider();
  //   window.articleSlider();
  //   window.gallerySlider();
  //   window.interestsSlider();
  //   window.programSlider();
  //   window.programSecondSlider();
  //   window.scienceSlider();
  //   window.scienceBigSlider();
  //   window.departmentSlider();
  //   window.fitSlider();
  //   window.specializationSlider();
  //   window.facultiesSlider();
  //   window.filterSlider();
  //   window.sidebarSlider();
  //   window.lobbySlider();
  //   window.includeSlider();
  //   window.mastersSlider();
  //   window.openDrop();
  // }
}
